import burgerking from "./burgerking.webp";
import ekahospital from "./ekahospital.webp";
import farmers from "./farmers.webp";
import hermina from "./hermina.webp";
import hokben from "./hokben.webp";
import kfc from "./kfc.webp";
import livingworld from "./livingworld.webp";
import mcd from "./mcd.webp";
import pizzahut from "./pizzahut.webp";
import popeyes from "./popeyes.webp";
import richeese from "./richeese.webp";
import shell from "./shell.webp";
import solaria from "./solaria.webp";
import starbucks from "./starbucks.webp";
import suzuki from "./suzuki.webp";
import total from "./total.webp";

const tenant = [
  burgerking,
  ekahospital,
  farmers,
  hermina,
  hokben,
  kfc,
  livingworld,
  mcd,
  pizzahut,
  popeyes,
  richeese,
  shell,
  solaria,
  starbucks,
  suzuki,
  total,
];

export default tenant;
